import { useQuery } from '@tanstack/react-query';
import { useOrgStore } from '@/stores/org-store';
import {
  listAgentConversations,
  type AgentConversationSummary,
  type ConversationListScope,
} from '@/services/agents/config';

// Prefix without the scope element - invalidating it hits both the 'mine'
// and 'shared' lists.
export const agentConversationsQueryPrefix = (
  orgId: string | undefined,
  agentId: string | undefined,
) => ['agent-conversations', orgId, agentId] as const;

export const agentConversationsQueryKey = (
  orgId: string | undefined,
  agentId: string | undefined,
  scope: ConversationListScope = 'mine',
) => [...agentConversationsQueryPrefix(orgId, agentId), scope] as const;

export const useAgentConversations = (
  agentId: string | undefined,
  scope: ConversationListScope = 'mine',
) => {
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useQuery<AgentConversationSummary[], Error>({
    queryKey: agentConversationsQueryKey(orgId, agentId, scope),
    queryFn: () => listAgentConversations(orgId!, agentId!, { scope }),
    enabled: !!orgId && !!agentId,
    staleTime: 30_000,
    retry: 1,
  });
};
